import {
  lightbox,
  LightboxConfiguration,
  LightboxPlayer,
} from "@fcxtech/player";
import { SvgIconProps } from "@mui/material";
import { useEffect, useState } from "react";
import palette, { AccentColors } from "theme/palette";
import * as S from "./VideoCanvas.styled";

type VideoCanvasProps = Omit<LightboxConfiguration, "origin" | "branding">;

type VideoPlayerProps = VideoCanvasProps & {
  playButtonColour: AccentColors;
};

export const getVcOrigin = (): string => {
  return `${window.location.protocol}//${window.location.host}`;
};

const getThumbnailImageData = async (vcId: string): Promise<string> => {
  const videoMetadataJson = await (
    await fetch(`${getVcOrigin()}/vc/${vcId}/data.json`)
  ).json();
  return videoMetadataJson.slides[0].variants.a.video.thumbnail;
};

const VideoPlayer = ({
  id: vcId,
  content,
  variant,
  playButtonColour,
}: VideoPlayerProps) => {
  const [player, setPlayer] = useState<LightboxPlayer | null>(null);
  const [thumbnailData, setThumbnailData] = useState<string>("");

  useEffect(() => {
    const fetchImageData = async () => {
      const imageData = await getThumbnailImageData(vcId);
      setThumbnailData(imageData);
    };
    fetchImageData();
  }, [vcId]);

  useEffect(() => {
    const newPlayer = lightbox({
      id: vcId,
      dataOrigin: `${getVcOrigin()}/vc`,
      variant,
      branding: {
        colors: {
          brandColor1: palette.video.brandColour1,
          brandColor2: palette.video.brandColour2,
          brandColor3: palette.video.brandColour3,
        },
        logo: {
          imageUrl: `${getVcOrigin()}/heywood_logo.png`,
        },
      },
      content,
    });

    setPlayer(newPlayer);
    return () => player?.destroy();
  }, [vcId, content]);

  const handleOpenVideo = () => {
    player?.show();
  };

  return (
    <S.PlayerWrapper onClick={handleOpenVideo}>
      <S.PlayButtonBox>
        <S.PlayCircleIcon
          viewBox={"2 2 20 20"}
          color={playButtonColour as SvgIconProps["color"]}
        />
        <S.PlayCircleBacking viewBox={"2 2 20 20"} />
      </S.PlayButtonBox>

      <S.ThumbnailImage src={thumbnailData} />
    </S.PlayerWrapper>
  );
};

export default VideoPlayer;
